module.exports = __webpack_public_path__ + "img/youmeiyou.e19fa744.png";